import React from "react";
import { Navigate } from "react-router-dom";
import { getRouterConfig } from "../config";

/**
 * not found component
 */
export default function NotFound() {
    const notFoundMode = getRouterConfig('notFound.mode', 'redirect')
    //
    if(notFoundMode === 'redirect') {
        const route = getRouterConfig('notFound.route', '/404')

        return <Navigate to={route} />
    } else if (notFoundMode === 'render') {
        const Component404 = getRouterConfig('notFound.component', React.Fragment)

        return <Component404 />
    }

    return <>{notFoundMode}</>
}
